import request from "@/utils/http.js";

export function queryIndexList(options) {
  return request({
    url: "/businessPro/indexColumn",
    method: "post",
    data: options,
  });
}

export function queryBannerList(options) {
  return request({
    url: "/businessPro/queryBanner",
    method: "post",
    data: options,
  });
}

// 门户导航配置
export function getNavBar(options) {
  return request({
    url: "/businessPro/portalConfig",
    method: "post",
    data: options,
  });
}

// 首页分类
export function queryHomePageColumn(options) {
  return request({
    url: "/businessPro/homePageColumn",
    method: "post",
    data: options,
  });
}

// Ucode
export function queryUcodeUrl(options) {
  return request({
    url: "/getUBTToken",
    method: "post",
    data: options,
  });
}

// 产品配置
export function queryAllProduct(options) {
  return request({
    url: "/businessPro/queryAllProduct",
    method: "post",
    data: options,
  });
}


